import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { Spinner } from "../../Components/Spinner/Spinner";
import NoInfoFound from "../../Components/NoInfoFound/NoInfoFound";
import SearchBox from "../../Components/SearchBox/SearchBox";
import Select from "react-select";
import ReactPaginate from "react-paginate";

import selectedAthelte from "../../redux/actionCreators/selectedAthlete";
import unSelectAthlete from "../../redux/actionCreators/selectedAthlete";

import style from "./ManageAthletes.module.css";

import { getPlainToken } from "../../assets/Js/tokenHandler";

import { callAPI } from "../../assets/Js/backendCommunication";

import projectSettings from "../../assets/Js/projectSettings";

import { Link, withRouter } from "react-router-dom";
import { getSubscription } from "../../assets/Js/localStorage";
import DisplayPicture from "../../Components/DisplayPicture/DisplayPicture";
import { apiResponseToast } from "../../assets/Js/apiResponseToast";
import deleteConfirmationPrompt from "../../assets/Js/deleteConfirmationPrompt";
import { immediateToast } from "izitoast-react";

const pageSize = 7;
const defaultTrack = "All Tracks";

const mapDispatchToProps = (dispatch) => {
  return {
    selectAthlete: (data) => dispatch(selectedAthelte(data)),
    unSelectAthlete: () => dispatch(unSelectAthlete()),
  };
};

const mapStateToProps = (state) => {
  return {
    gymData: state.gymData,
    userData: state.userData,
    trackChanged: state.trackChanged,
  };
};

const selectTrackDefaultValue = "Select Track";

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    class ManageAthletes extends Component {
      constructor() {
        super();

        this.searchRef = createRef();

        this.state = {
          showAthleteDetails: false,
          isLoading: true,
          totaPage: 0,
          currentPage: 0,
          selectedTrack: { label: selectTrackDefaultValue },
          searchResults: [],
          allTracks: [],
          allAtheltesData: [],
          availableAthletesInfo: [],
          selectedAthletesData: [],
          idsOfSelectecdAthletes: [],
        };
      }

      componentDidMount() {
        this.getAthletes();
      }

      componentDidUpdate(prevProps, prevState) {
        if (
          prevProps.trackChanged !== this.props.trackChanged ||
          prevProps.gymData !== this.props.gymData
        ) {
          this.getAthletes();
        }

        if (
          prevState.searchResults !== this.state.searchResults ||
          prevState.selectedTrack !== this.state.selectedTrack
        ) {
          let _selectedTrack =
            this.state.selectedTrack.label === selectTrackDefaultValue ||
            this.state.selectedTrack.label === defaultTrack
              ? ""
              : this.state.selectedTrack.label;

          const filteredResults = this.filterData({
            searchedResults: this.state.searchResults,
            selectedTrack: _selectedTrack,
          });

          this.setState({
            selectedAthletesData: filteredResults.slice(0, pageSize),
            availableAthletesInfo: filteredResults,
            totalPage: Math.ceil(filteredResults.length / pageSize),
            currentPage: 0,
          });
        }
      }

      getAthletes = async () => {
        if (this.props.gymData.length > 0) {
          let id = this.props.gymData[0].Id;
          let url = `${projectSettings.baseUrl}/gyms/${id}/getathletes`;
          let header = false;
          let data = null;
          let type = "GET";
          let token = getPlainToken();

          let response = "";

          if (response === "") {
            this.setState({ isLoading: true });
          }

          response = await callAPI(url, header, type, data, token);

          if (response) {
            this.setState({ isLoading: false });
            if (response.type === "error") {
              apiResponseToast(
                response.status,
                "getathletes",
                response.data.message
              );
            } else if (response.type === "success") {
              this.setState({
                selectedAthletesData: response.data.slice(0, pageSize),
                availableAthletesInfo: response.data,
                searchResults: response.data,
                allAtheltesData: response.data,
                totalPage: Math.ceil(response.data.length / pageSize),
              });
              this.perpareAllTracks();
            }
          }
        }
      };

      perpareAllTracks = () => {
        let tempAllTack = [];

        tempAllTack.push({ label: "All Tracks" });

        this.props.gymData[0].Tracks.map((currVal) => {
          tempAllTack.push({ label: currVal.Name, value: currVal.Id });
        });

        this.setState({ allTracks: tempAllTack });
      };

      selectThisAthlete = (athlete) => {
        this.setState({ showAthleteDetails: true });
        this.props.selectAthlete(athlete);
        this.props.history.push(
          `/dashboard/manageathletes/athletedetails/${athlete.id}?athletename=${athlete.name}`
        );
      };

      unSelectAthlete = () => {
        this.setState({ showAthleteDetails: false });
        this.props.unSelectAthlete();
      };

      hasTrack = (targetTracks) => {
        if (
          this.state.selectedTrack.label.toLowerCase() !==
          selectTrackDefaultValue.toLocaleLowerCase()
        ) {
          for (let currVal of targetTracks) {
            if (currVal.Name === this.state.selectedTrack.label) {
              return true;
            }
          }
          return false;
        } else {
          return true;
        }
      };

      removeFromGym() {
        deleteConfirmationPrompt(this.deleteFromGymApi);
      }

      deleteFromGymApi = async () => {
        const gymId = this.props.gymData[0].Id;

        let url = `${projectSettings.baseUrl}/gyms/removeuser/${gymId}`;
        let header = true;
        let data = {};
        let type = "POST";
        let token = getPlainToken();

        let response = "";

        if (this.state.idsOfSelectecdAthletes.length) {
          data.userIds = this.state.idsOfSelectecdAthletes;

          if (response === "") {
            this.setState({ isDeleting: true });
          }

          response = await callAPI(
            url,
            header,
            type,
            JSON.stringify(data),
            token
          );

          if (response) {
            this.setState({ isDeleting: false });

            if (response.type === "error") {
              apiResponseToast(
                response.status,
                "removeUser",
                response.data.message
              );
            } else if (response.type === "success") {
              this.setState({
                idsOfSelectecdAthletes: [],
              });

              if (this?.searchRef?.current) {
                this.searchRef.current.value = "";
              }

              this.getAthletes();
            }
          }
        } else {
          immediateToast("warning", {
            message: "Please Select An Athlete",
          });
        }
      };

      multiSelect = (id, isChecked) => {
        let _allSelectedAthletes = this.state.idsOfSelectecdAthletes;
        let _indexOfAthlete = _allSelectedAthletes.indexOf(id);

        if (isChecked) {
          if (_indexOfAthlete === -1) {
            _allSelectedAthletes = [..._allSelectedAthletes, id];
          }
        } else {
          _allSelectedAthletes = _allSelectedAthletes.filter(
            (eachId) => eachId !== id
          );
        }

        this.setState({
          idsOfSelectecdAthletes: _allSelectedAthletes,
        });
      };

      stopPropagation = (e) => {
        e.stopPropagation();
      };

      filterTrack = (selectedOption) => {
        this.setState({
          selectedTrack: selectedOption,
        });
      };

      handleSearch = (searchResults) => {
        this.setState({
          searchResults,
        });
      };

      filterData = ({ searchedResults, selectedTrack }) => {
        let _selectedAthletesData = [...searchedResults];

        if (selectedTrack) {
          if (selectedTrack.toLowerCase() === defaultTrack.toLowerCase()) {
            _selectedAthletesData = searchedResults;
          } else {
            _selectedAthletesData = searchedResults.filter((eachAthlete) =>
              eachAthlete.tracks.some(
                (eachTrack) =>
                  eachTrack.Name.toLowerCase() === selectedTrack.toLowerCase()
              )
            );
          }
        }

        return _selectedAthletesData;
      };

      handlePageChange = ({ selected }) => {
        this.setState({
          currentPage: selected,
          selectedAthletesData: this.state.availableAthletesInfo.slice(
            pageSize * selected,
            (selected + 1) * pageSize
          ),
        });
      };

      render() {
        return (
          <>
            <div
              className={`
               ${
                 getSubscription() === "true"
                   ? style.container1
                   : style.container
               } 
               p-3 colorBglite`}
            >
              <div className="container-fluid">
                <>
                  <div className="shadow-sm">
                    <div className="colorBgWhite pt-3 pl-3 pr-3 manageAthleteFilterBar">
                      <div className="container-fluid d-lg-flex justify-content-between flex-nowrap align-items-center">
                        <div className="mr-md-3 w-25 mr-xl-5">
                          <h2>Manage Athletes</h2>
                          <Link to="/dashboard" className="d-flex">
                            <i className="mdi mdi-home text-muted hover-cursor"></i>
                            <p className="text-muted mb-0 hover-cursor">
                              &nbsp;/&nbsp;Dashboard
                            </p>
                          </Link>
                        </div>
                        <div className="d-lg-flex w-100 justify-content-end align-items-end flex-wrap">
                          <SearchBox
                            searchRef={this.searchRef}
                            data={this.state.allAtheltesData}
                            propertyToLookFor={"name"}
                            changeHandler={this.handleSearch}
                            searchBoxStyles={`${style.filterFields} inputBox inputFieldStyle mr-2`}
                          />
                          <Select
                            className={`react-select mr-2 ${style.filterFields}`}
                            styles={customStyles}
                            placeholder="Selected Tracks"
                            value={{
                              label:
                                this.state.selectedTrack &&
                                this.state.selectedTrack.label,
                            }}
                            options={this.state.allTracks}
                            onChange={this.filterTrack}
                          />
                          <div className={style.removeButtonBox}>
                            <button
                              className={`basicFatBtnStyle mr-2 ${
                                style.removeFromGym
                              } ${
                                !this.state.idsOfSelectecdAthletes.length &&
                                `opacityLow`
                              }
                                `}
                              type="button"
                              disabled={
                                !this.state.idsOfSelectecdAthletes.length
                              }
                              onClick={() => this.removeFromGym()}
                            >
                              {this.state.isDeleting ? (
                                <div>
                                  <Spinner />
                                </div>
                              ) : (
                                <span>Remove From Gym</span>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={`card border-0`}>
                      <div className={`card-body ${style.tableBox}`}>
                        {this.state.isLoading ? (
                          <div className="w-100 p-5 colorBgWhite">
                            <Spinner />
                          </div>
                        ) : this.state.selectedAthletesData.length ? (
                          <>
                            <div className={`table-responsive`}>
                              <table className={`table table-striped`}>
                                <thead>
                                  <tr>
                                    <th>User</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Training Tracks</th>
                                    <th>Remove</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.selectedAthletesData.map(
                                    (currVal, index, arr) => {
                                      return (
                                        <tr
                                          className="pointerCursor"
                                          key={`tableRow${index}`}
                                          onClick={() =>
                                            this.selectThisAthlete(currVal)
                                          }
                                        >
                                          <td className="py-1">
                                            <DisplayPicture
                                              image={currVal.image}
                                            />
                                          </td>
                                          <td
                                            id={`name${index}`}
                                            style={{ maxWidth: "300px" }}
                                          >
                                            {currVal.name}
                                          </td>
                                          <td
                                            id={`email${index}`}
                                            style={{ maxWidth: "300px" }}
                                          >
                                            {currVal.email}
                                          </td>
                                          <td
                                            id={`tracks${index}`}
                                            style={{ maxWidth: "300px" }}
                                          >
                                            <div className="d-flex flex-wrap w-100">
                                              {currVal.tracks.map(
                                                (val, idx) => {
                                                  return (
                                                    <span
                                                      key={`tracks${idx}`}
                                                      className="badge-auto pt-1 pb-1 ml-1 mr-1 mb-1 width-fit-content"
                                                    >
                                                      {val.Name}{" "}
                                                    </span>
                                                  );
                                                }
                                              )}
                                            </div>
                                          </td>
                                          <td
                                            id={`checkBox${index}`}
                                            onClick={this.stopPropagation}
                                          >
                                            <div
                                              className={`${style.formCheck} form-check form-check-primary width-0 mx-auto`}
                                            >
                                              <label className="form-check-label width-0">
                                                <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.multiSelect(
                                                      currVal.id,
                                                      e.target.checked
                                                    );
                                                  }}
                                                />
                                                <i className="input-helper"></i>
                                              </label>
                                            </div>
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </>
                        ) : (
                          <NoInfoFound text={"No Athletes Found"} />
                        )}
                      </div>
                    </div>

                    {this.state.totalPage > 1 && (
                      <div className="d-flex justify-content-center mt-4">
                        <ReactPaginate
                          previousLabel="Previous"
                          nextLabel="Next"
                          pageClassName={`page-item pointerCursor`}
                          pageLinkClassName="page-link"
                          previousClassName={`page-item paginationControlBtn pointerCursor`}
                          previousLinkClassName="page-link"
                          nextClassName={`page-item paginationControlBtn pointerCursor`}
                          nextLinkClassName="page-link"
                          breakLabel="..."
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          pageCount={this.state.totalPage}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={this.handlePageChange}
                          containerClassName="pagination"
                          activeClassName="active"
                          forcePage={this.state.currentPage}
                        />
                      </div>
                    )}
                  </div>
                </>
              </div>
            </div>
          </>
        );
      }
    }
  )
);

const customStyles = {
  singleValue: () => ({
    color: "#969696",
  }),
};
